import { createAsyncThunk } from '@reduxjs/toolkit';
import { firestore } from '../../firebase';

export const fetchColleges = createAsyncThunk('colleges/fetchColleges', async () => {
  const collegesRef = firestore.collection('ecoles');
  const snapshot = await collegesRef.get();
  const colleges = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return colleges;
});


export const addCollege = createAsyncThunk('colleges/addCollege', async (collegeData, { dispatch }) => {
  try {
    const collegesRef = firestore.collection('ecoles');
    const newCollegeRef = await collegesRef.add({
      ...collegeData
    });
    const collegeId = newCollegeRef.id;
    const newCollege = { id: collegeId, ...collegeData };
    dispatch(fetchColleges());
    return newCollege;
  } catch (error) {
    console.error('Error creating user and adding college:', error);
    throw error;
  }
});

export const updateCollege = createAsyncThunk(
  'colleges/updateCollege',
  async (collegeData, { dispatch }) => {
    try {
      const collegesRef = firestore.collection('ecoles');
      const collegeId = collegeData.id; 
      await collegesRef.doc(collegeId).update({
        ...collegeData,
      });
      dispatch(fetchColleges());
      return collegeData; 
    } catch (error) {
      console.error('Error updating college:', error);
      throw error;
    }
  }
);
